// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-row[data-v-6bd82ed4] {\n    margin-left: 0;\n    margin-right: 0;\n}\na[data-v-6bd82ed4] {\n    color: var(--green-color) !important;\n}\na[data-v-6bd82ed4]:hover {\n    color: var(--green-color) !important;\n    text-decoration: underline !important;\n}\n", ""]);
// Exports
module.exports = exports;
